import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-main"
};
import { watch } from 'vue';
import { isTags } from '@/utils/tags';
import { generateTitle, watchSwitchLang } from '@/utils/i18n';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
export default {
  __name: 'AppMain',
  setup(__props) {
    const route = useRoute();

    /**
     * 生成 title
     */
    const getTitle = route => {
      let title = '';
      if (!route.meta) {
        // 处理无 meta 的路由
        const pathArr = route.path.split('/');
        title = pathArr[pathArr.length - 1];
      } else {
        title = generateTitle(route.meta.title);
      }
      return title;
    };

    /**
     * 监听路由变化
     */
    const store = useStore();
    watch(route, (to, from) => {
      if (!isTags(to.path)) return;
      const {
        fullPath,
        meta,
        name,
        params,
        path,
        query
      } = to;
      store.commit('app/addTagsViewList', {
        fullPath,
        meta,
        name,
        params,
        path,
        query,
        title: getTitle(to)
      });
    }, {
      immediate: true
    });
    watchSwitchLang(() => {
      store.getters.tagsViewList.forEach((route, index) => {
        store.commit('app/changeTagsView', {
          index,
          tag: {
            ...route,
            title: getTitle(route)
          }
        });
      });
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component,
          route
        }) => [_createVNode(_Transition, {
          name: "fade-transform",
          mode: "out-in"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: route.path
          }))], 1024))]),
          _: 2
        }, 1024)]),
        _: 1
      })]);
    };
  }
};